import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-play\"><defs><style type=\"text/css\"></style></defs><path d=\"M918.268 420.32c90.976 52.864 90.976 138.592 0 191.456L250.204 1000c-90.976 52.864-164.704 10.464-164.704-94.752V126.816C85.5 21.632 159.26-20.8 250.204 32.064l668.064 388.224z\" p-id=\"5245\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol